import * as React from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

export default function CdadHeaderFilterVehicleTab({setVehicleFilterCurrentTab}: any) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setVehicleFilterCurrentTab(newValue);
  };

  return (
    <Box sx={{ bgcolor: 'background.paper', paddingTop: "1.5rem", paddingRight: "1rem" }}>
      <Tabs  orientation="vertical" value={value} onChange={handleChange} sx={{ border: "1px solid rgba(0, 0, 0, 0.1)", borderRadius: "8px", width: "max-content" }}>
        <Tab sx={{textTransform :"none", fontWeight: "600", fontSize: "16px", alignItems: "flex-start"}} label="Vehicle" />
        <Tab sx={{textTransform :"none", fontWeight: "600", fontSize: "16px", alignItems: "flex-start"}} label="Production Facility" />
        <Tab sx={{textTransform :"none", fontWeight: "600", fontSize: "16px", alignItems: "flex-start"}} label="Parts" />
      </Tabs>
    </Box>
  );
}